import React, { useEffect, useState } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import {
  FilterSection,
  NotificationsTable,
  SearchBar,
} from "../../components/components";
import Header from "../../../../common/Header";
import Sidebar from "../../../../common/Sidebar";
import {
  mainLayoutStyles,
} from "../../../../constants";
import {
  getAllNotifications,
  notificationsSearch,
} from "../../hooks/NotificationsHooks";
import { useAuth } from "../../../../hooks";
import { useNotificationBadgeContext } from "../../../../providers/NotificationBadgeProvider";

const NotificationsContainer = () => {
  const { currentUser, organizationId } = useAuth();
  const { markNotificationsAsViewed } = useNotificationBadgeContext();
  const [notifications, setNotifications] = useState([]);
  const [allNotifications, setAllNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastDoc, setLastDoc] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [pageSize, setPageSize] = useState(25);

  useEffect(() => {
    // Mark notifications as viewed when the page loads
    markNotificationsAsViewed();
    handleGetAllNotifications();
  }, []); // Empty dependency array - only run on mount

  const handleGetAllNotifications = async (loadMore = false) => {
    try {
      setLoading(true);
      const orgId = organizationId || currentUser?.organization;
      
      console.log("Fetching notifications for organization:", orgId);
      console.log("Current user:", currentUser);
      
      if (!orgId) {
        console.error("No organization ID found");
        return;
      }

      const result = await getAllNotifications(
        orgId,
        pageSize,
        loadMore ? lastDoc : null
      );

      console.log("Notifications result:", result);
      console.log("Number of notifications fetched:", result.notifications.length);

      if (loadMore) {
        setNotifications(prev => [...prev, ...result.notifications]);
        setAllNotifications(prev => [...prev, ...result.notifications]);
      } else {
        setNotifications(result.notifications);
        setAllNotifications(result.notifications);
      }

      setLastDoc(result.lastDoc);
      setHasMore(result.hasMore);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    if (hasMore && !loading) {
      handleGetAllNotifications(true);
    }
  };

  const handleSearchNotifications = async (e) => {
    try {
      let value = e.target.value;
      if (value.length >= 1) {
        let notificationsSearchTemp = await notificationsSearch(
          allNotifications,
          value
        );
        setNotifications(notificationsSearchTemp);
      } else {
        setNotifications(allNotifications);
      }
    } catch (error) {
      console.log("error searching notifications:", error.message);
    }
  };

  const handlePageLoadingClose = () => {
    setLoading(false);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setLastDoc(null);
    setHasMore(false);
    // Reload with new page size
    handleGetAllNotifications();
  };

  return (
    <Box sx={{ display: "flex", width: "100%", paddingRight: 4 }}>
      <CssBaseline />
      <Header mainTitle={"Notifications"} bgColor="#fff" />
      <Sidebar />
      <Grid container style={{ ...mainLayoutStyles, background: "#fff" }}>
        <Grid container direction={"column"}>
          <FilterSection />
          <SearchBar
            placeholder={"Search notifications by user name or QuickTale title"}
            handleSearch={handleSearchNotifications}
          />
          <NotificationsTable
            notifications={notifications}
            hasMore={hasMore}
            onLoadMore={handleLoadMore}
            loading={loading}
            pageSize={pageSize}
            onPageSizeChange={handlePageSizeChange}
          />
        </Grid>
      </Grid>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handlePageLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default NotificationsContainer;
